import type { LucideIcon } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

const normalizeIconKey = (value?: string | null): string | null => {
  if (!value || typeof value !== 'string') {
    return null;
  }
  return value.trim().toLowerCase().replace(/[_\s]+/g, '-');
};

const toPascalCase = (value: string): string =>
  value
    .split('-')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');

export const resolvePortalMenuIcon = (
  value?: string | null,
  fallback: LucideIcon = LucideIcons.Link2,
): LucideIcon => {
  const key = normalizeIconKey(value);
  if (key) {
    const pascal = toPascalCase(key);
    const iconMap = (LucideIcons as { icons?: Record<string, LucideIcon> }).icons;
    if (iconMap && iconMap[pascal]) {
      return iconMap[pascal];
    }
    const candidates = [
      pascal,
      `Lucide${pascal}`,
      `${pascal}Icon`,
    ];
    for (const name of candidates) {
      const candidate = (LucideIcons as Record<string, unknown>)[name];
      if (typeof candidate === 'function') {
        return candidate as LucideIcon;
      }
    }
  }
  return fallback;
};
